import {useCallback, useEffect, useState} from "react";
import {Capacitor} from "@capacitor/core";
import {App} from "@capacitor/app";
import {
	AppUpdate,
	AppUpdateAvailability
} from "@capawesome/capacitor-app-update";

/**
 * Uses @capawesome/capacitor-app-update (Play / App Store metadata).
 * Only runs on native shells; web never calls the plugin (it would throw).
 */
export function useCapawesomeStoreUpdateOffer(): {updateAvailable: boolean} {
	const [updateAvailable, setUpdateAvailable] = useState(false);
	const [tick, setTick] = useState(0);

	const runCheck = useCallback(async () => {
		if (!Capacitor.isNativePlatform()) {
			setUpdateAvailable(false);
			return;
		}

		try {
			const info = await AppUpdate.getAppUpdateInfo();
			setUpdateAvailable(
				info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE
			);
		} catch {
			setUpdateAvailable(false);
		}
	}, []);

	useEffect(() => {
		void runCheck();
	}, [runCheck, tick]);

	useEffect(() => {
		if (!Capacitor.isNativePlatform()) {
			return;
		}
		const sub = App.addListener("resume", () => setTick((t) => t + 1));
		return () => {
			void sub.then((h) => h.remove());
		};
	}, []);

	return {updateAvailable};
}
